var map = {
	"./all-you-can-eat-ordering-system/content.de": [
		83760,
		3760
	],
	"./all-you-can-eat-ordering-system/content.de.ts": [
		83760,
		3760
	],
	"./all-you-can-eat-ordering-system/content.en": [
		77119,
		7119
	],
	"./all-you-can-eat-ordering-system/content.en.ts": [
		77119,
		7119
	],
	"./all-you-can-eat-ordering-system/content.nl": [
		9401,
		9401
	],
	"./all-you-can-eat-ordering-system/content.nl.ts": [
		9401,
		9401
	],
	"./all-you-can-eat-ordering-system/metadata": [
		25025,
		5025
	],
	"./all-you-can-eat-ordering-system/metadata.ts": [
		25025,
		5025
	],
	"./bakery-ordering-software/content.de": [
		82632,
		2632
	],
	"./bakery-ordering-software/content.de.ts": [
		82632,
		2632
	],
	"./bakery-ordering-software/content.en": [
		14852,
		4852
	],
	"./bakery-ordering-software/content.en.ts": [
		14852,
		4852
	],
	"./bakery-ordering-software/content.nl": [
		64843,
		4843
	],
	"./bakery-ordering-software/content.nl.ts": [
		64843,
		4843
	],
	"./bakery-ordering-software/metadata": [
		12768,
		2768
	],
	"./bakery-ordering-software/metadata.ts": [
		12768,
		2768
	],
	"./bowling-alley-digital-ordering/content.de": [
		79991,
		9991
	],
	"./bowling-alley-digital-ordering/content.de.ts": [
		79991,
		9991
	],
	"./bowling-alley-digital-ordering/content.en": [
		8571,
		8571
	],
	"./bowling-alley-digital-ordering/content.en.ts": [
		8571,
		8571
	],
	"./bowling-alley-digital-ordering/content.nl": [
		49554,
		9554
	],
	"./bowling-alley-digital-ordering/content.nl.ts": [
		49554,
		9554
	],
	"./bowling-alley-digital-ordering/metadata": [
		78047,
		8047
	],
	"./bowling-alley-digital-ordering/metadata.ts": [
		78047,
		8047
	],
	"./choosing-ordering-solution/content.de": [
		64001,
		4001
	],
	"./choosing-ordering-solution/content.de.ts": [
		64001,
		4001
	],
	"./choosing-ordering-solution/content.en": [
		19410,
		9410
	],
	"./choosing-ordering-solution/content.en.ts": [
		19410,
		9410
	],
	"./choosing-ordering-solution/content.nl": [
		71870,
		1870
	],
	"./choosing-ordering-solution/content.nl.ts": [
		71870,
		1870
	],
	"./choosing-ordering-solution/metadata": [
		80735,
		735
	],
	"./choosing-ordering-solution/metadata.ts": [
		80735,
		735
	],
	"./golf-clubs-digital-ordering/content.de": [
		83316,
		3316
	],
	"./golf-clubs-digital-ordering/content.de.ts": [
		83316,
		3316
	],
	"./golf-clubs-digital-ordering/content.en": [
		96659,
		6659
	],
	"./golf-clubs-digital-ordering/content.en.ts": [
		96659,
		6659
	],
	"./golf-clubs-digital-ordering/content.nl": [
		89005,
		9005
	],
	"./golf-clubs-digital-ordering/content.nl.ts": [
		89005,
		9005
	],
	"./golf-clubs-digital-ordering/metadata": [
		21332,
		1332
	],
	"./golf-clubs-digital-ordering/metadata.ts": [
		21332,
		1332
	],
	"./hotel-digital-ordering/content.de": [
		20966,
		966
	],
	"./hotel-digital-ordering/content.de.ts": [
		20966,
		966
	],
	"./hotel-digital-ordering/content.en": [
		7397,
		7397
	],
	"./hotel-digital-ordering/content.en.ts": [
		7397,
		7397
	],
	"./hotel-digital-ordering/content.nl": [
		9963,
		9963
	],
	"./hotel-digital-ordering/content.nl.ts": [
		9963,
		9963
	],
	"./hotel-digital-ordering/metadata": [
		88633,
		8633
	],
	"./hotel-digital-ordering/metadata.ts": [
		88633,
		8633
	],
	"./qr-ordering-restaurant-guide/content.de": [
		95766,
		5766
	],
	"./qr-ordering-restaurant-guide/content.de.ts": [
		95766,
		5766
	],
	"./qr-ordering-restaurant-guide/content.en": [
		40782,
		782
	],
	"./qr-ordering-restaurant-guide/content.en.ts": [
		40782,
		782
	],
	"./qr-ordering-restaurant-guide/content.nl": [
		14386,
		4386
	],
	"./qr-ordering-restaurant-guide/content.nl.ts": [
		14386,
		4386
	],
	"./qr-ordering-restaurant-guide/metadata": [
		28140,
		8140
	],
	"./qr-ordering-restaurant-guide/metadata.ts": [
		28140,
		8140
	],
	"./restaurant-kpi-guide/content.de": [
		61056,
		1056
	],
	"./restaurant-kpi-guide/content.de.ts": [
		61056,
		1056
	],
	"./restaurant-kpi-guide/content.en": [
		29791,
		9791
	],
	"./restaurant-kpi-guide/content.en.ts": [
		29791,
		9791
	],
	"./restaurant-kpi-guide/content.nl": [
		24580,
		4580
	],
	"./restaurant-kpi-guide/content.nl.ts": [
		24580,
		4580
	],
	"./restaurant-kpi-guide/metadata": [
		76619,
		6619
	],
	"./restaurant-kpi-guide/metadata.ts": [
		76619,
		6619
	],
	"./self-order-kiosks-for-hospitality/content.de": [
		26780,
		6780
	],
	"./self-order-kiosks-for-hospitality/content.de.ts": [
		26780,
		6780
	],
	"./self-order-kiosks-for-hospitality/content.en": [
		52952,
		2952
	],
	"./self-order-kiosks-for-hospitality/content.en.ts": [
		52952,
		2952
	],
	"./self-order-kiosks-for-hospitality/content.nl": [
		71695,
		1695
	],
	"./self-order-kiosks-for-hospitality/content.nl.ts": [
		71695,
		1695
	],
	"./self-order-kiosks-for-hospitality/metadata": [
		29913,
		9913
	],
	"./self-order-kiosks-for-hospitality/metadata.ts": [
		29913,
		9913
	],
	"./snackbar-digital-ordering/content.de": [
		86361,
		6361
	],
	"./snackbar-digital-ordering/content.de.ts": [
		86361,
		6361
	],
	"./snackbar-digital-ordering/content.en": [
		2451,
		2451
	],
	"./snackbar-digital-ordering/content.en.ts": [
		2451,
		2451
	],
	"./snackbar-digital-ordering/content.nl": [
		55713,
		5713
	],
	"./snackbar-digital-ordering/content.nl.ts": [
		55713,
		5713
	],
	"./snackbar-digital-ordering/metadata": [
		88466,
		8466
	],
	"./snackbar-digital-ordering/metadata.ts": [
		88466,
		8466
	],
	"./the-new-hospitality-industry/content.de": [
		94995,
		4995
	],
	"./the-new-hospitality-industry/content.de.ts": [
		94995,
		4995
	],
	"./the-new-hospitality-industry/content.en": [
		82050,
		2050
	],
	"./the-new-hospitality-industry/content.en.ts": [
		82050,
		2050
	],
	"./the-new-hospitality-industry/content.nl": [
		33930,
		3930
	],
	"./the-new-hospitality-industry/content.nl.ts": [
		33930,
		3930
	],
	"./the-new-hospitality-industry/metadata": [
		82275,
		2275
	],
	"./the-new-hospitality-industry/metadata.ts": [
		82275,
		2275
	],
	"./the-psychology-behind-upselling/content.de": [
		73298,
		3298
	],
	"./the-psychology-behind-upselling/content.de.ts": [
		73298,
		3298
	],
	"./the-psychology-behind-upselling/content.en": [
		17494,
		7494
	],
	"./the-psychology-behind-upselling/content.en.ts": [
		17494,
		7494
	],
	"./the-psychology-behind-upselling/content.nl": [
		49295,
		9295
	],
	"./the-psychology-behind-upselling/content.nl.ts": [
		49295,
		9295
	],
	"./the-psychology-behind-upselling/metadata": [
		64343,
		4343
	],
	"./the-psychology-behind-upselling/metadata.ts": [
		64343,
		4343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 10386;
module.exports = webpackAsyncContext;